import {BrowserRouter, Route, Routes} from 'react-router-dom'
import React, {Suspense, lazy} from 'react'

import {ScrollToTop} from 'router/scrollToTop'
import {relativeUrls} from 'router/relativeUrls'

const CaseStudy = lazy(() => import('pages/CaseStudy'))
const Footer = lazy(() => import('components/Footer'))
const Menu = lazy(() => import('components/Menu'))
const Nav = lazy(() => import('components/Nav'))
const Home = lazy(() => import('pages/Home'))
const Pricing = lazy(() => import('pages/Pricing'))
const Contact = lazy(() => import('pages/Contact'))
const Terms = lazy(() => import('pages/Terms'))
const NoMatch = lazy(() => import('pages/NoMatch'))

const Loading: React.FC = () => <div style={{height: '100vh'}} />

export const AppRouter: React.FC = () => (
	<BrowserRouter>
		<ScrollToTop />
		<Suspense fallback={<Loading />}>
			<Nav />
			<Menu />
			<Routes>
				<Route element={<Home />} path={relativeUrls.home} />
				<Route element={<CaseStudy />} path={relativeUrls.caseStudy} />
				<Route element={<Pricing />} path={relativeUrls.pricing} />
				<Route element={<Contact />} path={relativeUrls.contact} />
				<Route element={<Terms />} path={relativeUrls.terms} />
				<Route element={<NoMatch />} />
			</Routes>
			<Footer />
		</Suspense>
	</BrowserRouter>
)
